import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output, SimpleChanges, ViewChild, ElementRef
} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {
  VisitPlanResourceHoldersMultiSelectListComponent
} from "../visit-plan-resource-holders-multi-select-list/visit-plan-resource-holders-multi-select-list.component";

require('./visit-plan-resource-holders-multi-select.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-resource-holders-multi-select',
  templateUrl: './visit-plan-resource-holders-multi-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanResourceHoldersMultiSelectComponent implements OnChanges, AfterViewInit {

  @Input() visitPlanId: string;
  @Input() visitScheduleId: string;
  @Input() selectedIds: string[];
  @Input() branchIds: string[];
  @Input() ngPlaceholder: string;
  @Input() isDisabled: boolean;
  @Input() isRequired: boolean;
  @Output() onChange = new EventEmitter<{ agentIds: string[] }>();

  @ViewChild('inputRef', {static: true}) inputRef: ElementRef;

  public selectedText: string = '';

  constructor(@Inject(PanelService) private panelService: PanelService,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
              @Inject(TranslateService) private translateService: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedText();
    }
  }

  ngAfterViewInit() {
    this._setSelectedText();
  }

  onShowPanel(event) {
    if (!!this.isDisabled) {
      return;
    }

    const panel = this.panelService.open(VisitPlanResourceHoldersMultiSelectListComponent, event, {
      selectedIds: this.selectedIds,
      branchIds: this.branchIds,
      visitPlanId: this.visitPlanId,
      visitScheduleId: this.visitScheduleId
    });

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        if (data === null) {
          return;
        }
        const agentIds = data?.agentIds !== undefined ? data.agentIds : this.selectedIds;
        this.onChange.emit({agentIds});
      });
    }
  }

  private _setSelectedText() {
    this.selectedText = this.selectedIds?.length ?
      `${this.selectedIds.length} ${this.translateService.instant('Agents')}` : '';
    this.cdr.detectChanges();
  }

}
